import React from 'react'
import Button from '@Components/Buttons/Button'

interface ReviewActionsProps {
    onApprove: () => void
    onDeny: () => void
}

const ReviewActions = ({ onApprove, onDeny }: ReviewActionsProps) => (
    <>
        <p className="ct-review-note">
            This request requires your approval. Please review the details below and choose to approve or deny the
            catalog transfer.
        </p>
        <div className="ct-review-actions">
            <p className="ct-review-actions-title">Review Actions</p>
            <div className="ct-review-actions-buttons">
                <Button mainColor type="primary" onClick={onApprove}>
                    Approve
                </Button>
                <Button mainColor type="primary" onClick={onDeny}>
                    Deny
                </Button>
            </div>
        </div>
    </>
)

export default ReviewActions
